import React from 'react';
import {Tooltip} from "antd";
import recordIcon from "../../image/chatRecord/recordicon.png";
import PubSub from "pubsub-js"

const RecordIcon = (props) => {

    //PubSub 发布消息，tab跳转到聊天记录选项
    const linkToRecord = () => {
        PubSub.publish('LINK_TO_CHAT_RECORD', '3')
    }
    return (
        <>
            <Tooltip placement="top" title={'聊天记录'}>
                <img src={recordIcon} className={'im-remind'} onClick={linkToRecord}/>
            </Tooltip>
        </>
    );
}

export default RecordIcon;